<template>
  <div class="page-survey-chat">
    <template v-if="listData && listData.length">
      <ani-stage
        :items="listData"
        :scroll-container="scrollContainer"
        :support-animation="true"
        ref="refAniStage"
      >
        <template v-slot:card="{it, idx, cardState, vwSize, supportAnimation}">
          <ani-card-content
            :id="`card_inst_${it.code}`"
            :owner-state="cardState"
            :vw-size="vwSize"
            :item="it"
            :ref="`ref-card-content-${idx}`"
            :index="idx"
            :before-submit="_beforeContentSubmit"
            :support-animation="supportAnimation"
            @submitted="_onCardContentSubmitted"
            @content-animation-start="_onCardContentAnimationStart"
            @content-animation-end="_onCardContentAnimationEnd"
            @image-preview="_onImagePreview"
          >
            <template v-slot:input="{cbs}">
              <content-input-resolver :meta="it" :idx="idx" :cbs="cbs"/>
            </template>
          </ani-card-content>
        </template>

        <template v-slot:tailer>
          <div
            class="tailer-wrap"
            v-show="isNoMore && !isSubmitting"
          >
            <one-button
              @click.native="_submitQuestions"
              type="warn"
              plain
            >
              提交
            </one-button>
          </div>
        </template>
      </ani-stage>
    </template>
  </div>
</template>

<script>
  import { AniStage } from '@/components/AniStageCards'
  import AniCardContent from './AniCardContent'
  import { contentInputResolver } from './InputAdapters'
  import { injectMixins } from '@/services'
  import { delay, getTextContentFromHtml, isDev, isWeixin } from '@/helpers'
  import sensors from '@/utils/sensors'

  export default {
    name: 'PageSurveyChat',

    mixins: [
      injectMixins
    ],

    data () {
      return {
        isSubmitting: false,
        scrollContainer: '#app',
        listData: [],
        isNoMore: false
      }
    },

    async created () {
      try {
        this.pageLoading = true

        this._ensureCpCode()
        await this._ensureBaseInfo()

        const questions = await this.gActions.getChatQuestions({ cpCode: this.cpCode, type: 1 })
        console.log('[MOCK-RECEIVED]', questions)

        this.listData = questions

        // base form data
        const vm = this
        const $t = this.$counter = {
          _timer: null,

          start () {
            $t._timer = setInterval(() => {
              vm.$formData.timeLength += 1
            }, 1000)
          },

          stop () {
            $t._timer && clearInterval($t._timer)
          }
        }

        this.$formData = {
          // consumerID: '',
          cpCode: this.cpCode,
          taskCode: this.taskCode,
          timeLength: 0
        }

        this.$counter.start()

      } catch (e) {
        console.error(e)
      } finally {
        this.pageLoading = false
      }
      // 神策埋点
      const sensorConfig = {
        app_title: document.title,
        app_button: '开始测评'
      }
      sensors.appWebClick(sensorConfig)
    },

    mounted () {
      this.$watch('baseInfo', (baseInfo) => {
        if (!baseInfo) return
        document.title = (baseInfo.name || '壹零医')
      }, {
        immediate: true
      })

      // this.$watch('isSubmitting', (a) => {})
    },

    methods: {
      _onImagePreview (src) {
        if (!isWeixin()) return

        wx.previewImage({
          urls: [src]
        })
      },

      _onCardContentAnimationStart () {
        document.body.classList.add('ani-lock-screen')
      },

      _onCardContentAnimationEnd () {
        setTimeout(() => {
          document.body.classList.remove('ani-lock-screen')
        }, 24)
      },

      _releaseLockedScreen () {
        this.$refs.refAniStage.releaseLockedScreen()
        document.body.classList.remove('ani-lock-screen')
      },

      async _submitQuestions () {
        if (this.isSubmitting) {
          return
        }

        // try to fix locked screen
        this._releaseLockedScreen()

        if (!window.confirm('题目都完成，现在要提交吗?')) {
          return
        }

        try {
          const formData = this._collectFormData()

          this.isSubmitting = true
          this.$toast.text('结果评测中...', 'default')

          await delay(1000) // TODO: fake status

          const result = await this.gActions.saveChatQuestions(formData)

          if (result && result.propose) {
            result.propose = getTextContentFromHtml(result.proposeHtml)
          }

          this.gState.tmpChatResult = result

          console.debug('[RESULT] -> ', result)

          await delay()
          this.$router.replace(`/survey/detail?code=${this.cpCode}`).catch(null)
          this.$toast.hide()
        } catch (e) {
          console.error(e)
        } finally {
          this.isSubmitting = false
        }
      },

      _collectFormData () {
        const formData = {
          ...this.$formData
        }

        let invalidatedAnswers = []

        // resolve questions
        let content = Array.from(Array(this.listData.length)).map((_, idx) => {
          const refContent = this.$refs[`ref-card-content-${idx}`]
          const rawItem = { ...refContent.item }

          // TODO: fix backend wried key ....
          if (rawItem.hasOwnProperty('showType')) {
            rawItem.subType = 1
          }

          if (rawItem.hasOwnProperty('question')) {
            delete rawItem.question
          }

          // TODO: resolve answer results
          const answer = rawItem.answer = refContent.getInputAdapterValue()

          if (refContent.ownerState && rawItem.required !== false) { // 未激活的问题，可能是忽略的题目
            if (!answer || (Array.isArray(answer) && (!answer.length || !answer[0].subAnswer))) {
              invalidatedAnswers.push(rawItem)
            }
          }

          return rawItem
        })

        if (invalidatedAnswers.length) {
          const scroller = this.__appZenScroller__
          const item = invalidatedAnswers[0]
          if (scroller && item.code) {
            const cardEl = document.querySelector('#card_inst_' + item.code)
            if (cardEl) {
              scroller.to(cardEl, 300)
              this.$toast.text('必填哟')
            }
          }

          throw new Error('Invalidated Form Data')
        }

        formData.content = content

        if (this.isPreview) {
          formData.isPreview = 1
        }

        return formData
      },

      _beforeContentSubmit (index, refCardContent) {
        if (!refCardContent.item.required) {
          return
        }

        if (
          !refCardContent.localResponseValue ||
          refCardContent.localResponseValue === '未设置'
        ) {
          this.$toast.text('必填哟')
          return Promise.reject(null)
        }
      },

      _resolveItemIndexByIdentity (identity) {
        let toIdx = null

        if (identity && this.listData) {
          this.listData.some((it, i) => {
            if (it.code === identity) {
              toIdx = i
              return true
            }
          })
        }

        return toIdx
      },

      _onCardContentSubmitted ([index, selectedRawRefOption = null]) {
        const { refAniStage } = this.$refs

        // this.$toast.success('SUBMITTED')
        this._tryFixKeyboard()

        // TODO: ---
        if (index === refAniStage.currentIndex) {
          try {
            // set progress index
            refAniStage.settledProgressNo()

            if (selectedRawRefOption && selectedRawRefOption.nextCode) {
              const toItemIndex = this._resolveItemIndexByIdentity(selectedRawRefOption.nextCode)

              if (isDev && toItemIndex <= index) {
                this.$toast.error('题目不能往回跳转 .')
                throw new Error(null)
              }

              if (toItemIndex && toItemIndex > index) {
                refAniStage.nextCard(toItemIndex)
                refAniStage.settledProgressNo()
                return
              }

              console.warn('[跳转条目有误] toItemIndex ->', toItemIndex)
            }

            refAniStage.nextCard()
          } catch (e) {
            if (e.message === 'NO_MORE') {
              // this.$toast.text('没有了')
              this.isNoMore = true

              this._submitQuestions().catch(null)
              return
            }

            console.error(e)
          }
        }
      },

      _tryFixKeyboard () {
        if (isWeixin()) {
          setTimeout(() => {
            window.scrollTo(0, 0)
          }, 100)
        }
      }
    },

    components: {
      AniStage,
      AniCardContent,
      contentInputResolver
    }
  }
</script>

<style lang="scss">
  .page-survey-chat {
    .tailer-wrap {
      box-sizing: border-box;
      width: 100%;
      padding: 15px;

      position: relative;
      top: -120px;
      .weui-btn_plain-warn{
        border: 1px solid #3DD3CB;
        color: #3DD3CB;
      }
    }
    .weui-cells_checkbox{
      .weui-icon-checked:before {
        content: '\EA01';
        color: #3DD3CB !important;
        font-size: 23px;
        display: block;
      }
    }
  }
</style>
